import apiClient from "../apiClient";
import { API_ROUTES } from "../../config/baseURL";

export const getAyudaDetalle = async (actividad_consecutivo, grupo, subgrupo) => {
  const res = await apiClient.get(API_ROUTES.ayudasDetalle, {
    params: { actividad_consecutivo, grupo, subgrupo },
  });
  return res.data;
};

export const getAllAyudas = async () => {
  const res = await apiClient.get(API_ROUTES.ayudas);
  return res.data;
};

export const saveAyuda = async (data) => {
  const res = await apiClient.post(API_ROUTES.ayudas, data);
  return res.data;
};

export const resetAyudasIsaAdmin = async (data) => {
  const token = data?.token;
  const payload = { confirm: data?.confirm };
  const res = await apiClient.post(API_ROUTES.ayudasAdminReset, payload, {
    headers: {
      "X-Reset-Token": token,
    },
  });
  return res.data;
};

